export default __webpack_public_path__ + "media/images/corporate/hero/md-a83c06d051b97591cfbf5f3d0e9009ed.png";